module.exports = __webpack_public_path__ + "img/file-pptx.52be9c81.svg";